import * as React from 'react';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { ParagraphBigNumber } from '@components/Paragraphs';
import { Headline, SubHeadlineSection } from '@components/Headlines';
import theme from '@theme';
import {
  pb, my, px, py
} from 'styled-components-spacing';
import { colors } from '@components/ListItemFacility/styles';

export const StyledMaxWidth = styled.div`
  background-color: ${theme.colors.white};
`;

export const StyledCover = styled.div`
  margin: 0 auto;
  max-width: 1200px;
  ${py(3)}
  ${breakpoint('mobile', 'desktop')`
  ${px(3)}
  ${pb(4)}
  `}

  ${breakpoint('desktop')`
  ${pb(4)}
  `}
`;

export const StyledListItem = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledListItemSteps = styled(StyledListItem)`
  height: ${props => props.number && '100px'};
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
`;

export const StyledHeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledArrowSnakeLeft = styled.div`
  > svg {
    margin-left: 80px;
  }

  height: 200px;
  width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  ${breakpoint('mobile', 'desktop')`
  display: none;
`}
`;

export const StyledArrowSnakeRight = styled(StyledArrowSnakeLeft)`
  > svg {
    margin-right: 80px;
    margin-left: 0px;
  }
`;

export const StyledHorizontalArrowWrapper = styled.div`
  width: ${props => (props.mobile ? '25%' : '100%')};
  ${props => props.MobileReversedArrow && 'transform: rotate(180deg);'}
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
  }
`;

export const StyledStepsDetails = styled.div`
  width: 110%;
  align-items: center;
   div{
    &:nth-child(1){
      color: rgb(36, 42, 56);
    }
    &:nth-child(2){
      color: #7E8597;
    }
  }
 }
}
`;

export const StyledHeadingSection = styled.div`
  width: 100%;
  font-style: inherit;
  color: ${colors.darkNaviBlue} !important;
  font-weight: 600;
  font-size: 17px;
  line-height: 20px;
  letter-spacing: 0.5px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  overflow-wrap: break-word;
  ${breakpoint('mobile', 'tablet')`
   font-size: 14px;
   font-weight: 700;
   line-height: 1.2;
`}
`;

export const StyledDetailSection = styled.div`
width: 100%;
margin-top: 10px;
overflow-wrap: break-word;
font-weight: 500;
font-size: 14px;
line-height: 17px;
text-align: center;
letter-spacing: 0.5px
display: flex;
justify-content: center;
align-items: center;
${breakpoint('mobile', 'tablet')`
align-items: flex-start;
font-weight: 600;
font-size: 10px;
line-height: 15px;
margin-top: 4px;
 `}
`;

export const StyledStepsContainer = styled.div`
width: 100%;
display: none;
justify-content: space-evenly;
align-items: flex-start;
${breakpoint('mobile', 'tablet')`
${props =>
    !props.MobileStepContainer
  && `
display: flex;
justify-content: space-evenly;
> div{
  &:nth-child(4) {
    display: none;
  }
  &:nth-child(5) {
    display: none;
  }
  &:nth-child(6) {
    display: none;
  }
  &:nth-child(7) {
    display: none;
  }
}
`}
${props =>
    props.MobileStepContainer
  && `display: flex;
justify-content: space-evenly;
flex-direction: row-reverse;
> div{
  &:nth-child(1) {
    display: none;
  }
  &:nth-child(2) {
    display: none;
  }
  &:nth-child(3) {
    display: none;
  }
  &:nth-child(4) {
    display: none;
  }
}
`}
`}

${breakpoint('tablet', 'desktop')`
 ${props => !props.MobileStepContainer && 'display: flex;'}
`}

${breakpoint('desktop')`
${props => !props.MobileStepContainer && 'display: flex;'}
`}
`;

export const StyledSteps = styled.div`
  width: 20%;
  align-items: center;
  ${breakpoint('mobile', 'tablet')`
  width: 40%;
`}
`;

export const StyledUpperStep = styled.div`
  width: 100%;
  height: 20vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
    aspect-ratio: 1;
  }

  ${breakpoint('mobile', 'tablet')`
  height: 40vw;
`}
  ${breakpoint('tablet')`
    height: 20vw;
    max-height: 300px;
`}
`;
export const StyledLowerStep = styled.div`
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const StyledArrowStepContainer = styled.div`
  width: 4%;
  align-self: stretch;
  ${breakpoint('mobile', 'tablet')`
   width: 10%;
`}
`;

export const StyledDownArrowContainer = styled.div`
  display: none;
  width: 100%;
  justify-content: end;
  align-items: center;
  ${my(3)}
  ${breakpoint('mobile', 'tablet')`
   display: flex;
  `}
`;
export const SyledDownArrowStep = styled.div`
  width: 40%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 2.5%;
  transform: rotate(90deg);
`;

export const StyledBigNumberLeft = styled(ParagraphBigNumber)`
  font-size: 100px;
  font-style: inherit;
  font-weight: 500;
  color: #61b2d8;
  display: flex;
  align-items: center;
  justify-content: center;

  ${breakpoint('mobile', 'tablet')`
     font-size: 36px;
     font-weight: 700;
  `}

  ${breakpoint('tablet', 'desktop')`
    font-size: 80px;
   `}
`;

export const StyledSubHeadlineSection = styled(SubHeadlineSection)`
  text-align: center;
`;

export const StyledSection = styled.section`
  position: relative;
`;

export const StyledHeadlineText = styled(props => <Headline {...props} component="h3" />)`
  font-weight: 600;
  ${theme.typography.Raleway}
`;
